// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3vS78","cell":"ColumnAccessor_cell__3mW1x","firstCellAccent":"ColumnAccessor_firstCellAccent__1Wihn"};